// extracted by mini-css-extract-plugin
export default {"JobworksPartiesPage":"JobworksPartiesPage_JobworksPartiesPage__-QlL4"};